import { render, staticRenderFns } from "./Blade1.vue?vue&type=template&id=a24b0f40"
import script from "./Blade1.vue?vue&type=script&lang=js"
export * from "./Blade1.vue?vue&type=script&lang=js"
import style0 from "./Blade1.vue?vue&type=style&index=0&id=a24b0f40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports